<template lang="pug">
    div.tab-content.scrollbar.is-scrollable
        section.detail-section
            div.item-info
                div.item-id {{ audienceInfo.id }}
                div.item-value
                    div.item-status(:title="audienceInfo.status" :class="itemCssClasses(audienceInfo.status)")
                    input.audience-label.item-label(
                        :class="inputClass"
                        type="text"
                        id="audience-label"
                        name="audience-label"
                        placeholder="Choose a nice name for your audience"
                        v-model="audienceFormLabel"
                        :title="audienceFormLabel"
                        v-validate="'min:1|max:200|required'"
                        @blur="handleResetFieldOnLeave('label')"
                        @keyup.enter="editAudienceInfo('label', null, $event)")
                    span.form-validate-error {{ errors.first('audience-label') }}

            div.sub-header.l-flex-row--between
                div.sub-header-title Details
            div.info-content

                //- AUDIENCE TYPE
                div.info-block
                    div.label Type
                    div.value.l-flex-row.l-align-center {{ this.audienceInfo.type === 'cclones' ? 'Cclone' : this.audienceInfo.type === 'georadar' ? 'Georadar' : 'Audience' }}

                //- CcloneId if audience is Cclone
                div.info-block(v-if="this.audienceInfo.type === 'cclones'")
                    div.label CcloneID
                    div.info-block-ccloneid.l-flex-row.l-align-center(
                        :class="classInfoBlockCcloneid"
                        title="go to builder cclone"
                        @click="RedirectToBuilder(audienceInfo.strong_classifiers_family_id)"
                    )
                        div.value {{audienceInfo.strong_classifiers_family_id}}
                        svg-icon(
                            v-if="hasUserAccessToCclone"
                            name='go' size="small")

                //- START DATE - END DATE
                div.info-block
                    div.label Date
                    div.info-block-date.l-flex-row.l-align-center
                        div.date-start {{ audienceInfo.createdAt }}
                        svg-icon.date-separator(name='arrow-direction_right' size="small")
                        div.date-end(v-if="!monitoringActionAllowed") {{ audienceInfo.endDate }}
                        div.item-value(v-else)
                            el-date-picker.date-end(
                                v-model="audienceFormEndDate"
                                name="end_date"
                                id="end_date"
                                editable=true
                                clearable=false
                                type="date"
                                format="yyyy-MM-dd"
                                value-format="yyyy-MM-dd"
                                placeholder="Audience end date"
                                :picker-options="endDateOptions"
                                v-validate="'date_format:yyyy-MM-dd|required'"
                                @blur="handleResetFieldOnLeave('endDate')"
                                @change="editAudienceInfo('endDate', null, $event)")
                            //- span.form-validate-error {{ errors.first('end_date') }}

                //- STATUS
                switchItem.info-block.switch-status.l-flex-box.l-align-center(
                    v-if="monitoringActionAllowed"
                    label="Status"
                    type="audience-status"
                    inputName="audience-status"
                    :isSwitchActive="audienceStatus"
                    :loadData="editAudienceInfo"
                    :noFlexBetween="true"
                )
                //- BOOTSTRAP
                div.info-block.l-flex-box(v-if="displayBootstrap")
                    div.label Bootstrap
                    div.item-value
                        div.value(v-if="!monitoringActionAllowed") {{ audienceInfo.bootstrap }}
                        div.value(
                            v-else-if="isThirdPartyBootstrap"
                            title="Bootstrap is not available, because audience contains 3rd Party only.") N/A
                        template(v-else)
                            button.btn-pale.btn--small.btn--round.info-block-bootstrap(
                                v-if="audienceInfo.bootstrap === 'none' && isBootstrapAllowed"
                                :class="{ 'ui-disabled': disableBootstrap || formulaLoading }"
                                @click="bootstrapAudience()") Start
                            div.value(v-else-if="isBootstrapAllowed") {{ audienceInfo.bootstrap }}
                            div.value(v-else) N/A

                        div.form-validate-error(v-if="displayBootstrap && disableBootstrap && !isThirdPartyBootstrap && ['none', 'failed'].includes(audienceInfo.bootstrap)") {{ bootstrapWarning }}


        section.detail-section
            div.sub-header.l-flex-row--between
                div.sub-header-title Emails
            //- email
            div.info-block
                div.label Email
                div.item-value
                    input.email-input.no-icon(
                        v-if="editEmailAudience"
                        :class="inputClass"
                        id="audience-email"
                        name="audience-email"
                        type="text"
                        placeholder="user@weborama.com"
                        v-model="audienceFormEmail"
                        v-validate="'min:1|max:255|required|email'"
                        style="text-overflow: ellipsis;width: 100%;padding-left:0;padding-right:21px"
                        :title="audienceFormEmail"
                        @blur="handleResetFieldOnLeave('email')"
                        @keyup.enter="editAudienceInfo('email', null, $event)")
                    div.info-email(v-else)
                        span(:title="audienceFormEmail").email-audience {{audienceFormEmail}}
                    svg-icon.cursor.edit-action(
                        v-if="monitoringActionAllowed"
                        @click.native="toggleEditEmail"
                        name='edit' size="small")
                    span.form-validate-error(v-if="errors.first('audience-email')") 'The audience email field must be a valid email

            //- CC Mail
            div.info-block
                div.label
                    span Cc
                    span.list-counter(v-if="monitoringActionAllowed") {{ audienceFormCc.length }} /10
                div.item-value(
                    v-if="audienceFormCc.length >= 1"
                    :class="{'cursor': monitoringActionAllowed}"
                    @click="displayEdit('cc')")
                    div.value.value-list.cc-email
                        span.value-item(
                            :title="cc"
                            v-for="(cc, idx) of audienceFormCc" :key="idx"
                            :class="{'no-edit': !monitoringActionAllowed}") {{ cc }}
                    svg-icon.cursor.edit-action(
                        v-if="monitoringActionAllowed"
                        name='edit' size="small")
                button.btn--xsmall.btn-add(
                v-if="displayAddCc"
                @click="displayEdit('cc')") + add

            //- Modal single edit
            transition(name="slide-fade")
                div.edit-single-wrapper(v-if="displayEditSingleInput.cc")
                    EmailCcField(
                        parent="Monitoring"
                        placeholder="Add, edit an email cc"
                        @formCcListUpdate="updateFormCcList"
                        monitoringType="audience"
                        :defaultValues="defaultCcValues"
                        :maxItems="10"
                    )
                    footer.l-flex-row--rev
                        button.btn-cancel.btn--small.btn--round(@click="closeEmailCcWrapper") cancel
                        button.btn.btn-pale.btn--small.btn--round(
                            :class="{'ui-disabled': disableCcSave}"
                            @click="editAudienceInfo('cc', null)") save

        //- TAGS
        section.detail-section
            div.sub-header(@click="toggleSection('hideAllTags')")
                div.sub-header-title.cursor.l-flex-row.l-align-center(:class="toggleExpandTagsSection")
                    svg-icon.mg-r-4(name='arrow_bottom' size="small")
                    span Tags
                    span.list-counter(v-if="monitoringActionAllowed") {{ audienceTagsList.length + ' / ' + maxTagsLimit }}
                div.sub-header-subtitle(v-if="monitoringActionAllowed && showAllTags") Tags are limited to 20 characters.

            transition(name="slide-fade")
                div(v-show="showAllTags")
                    div.taglist-wrapper
                        div.criterion-taglist
                            div.criterion-tag.l-flex-row.l-align-center(v-for="(tag, tKey) in orderedTags" :key="tKey" v-if="showAllTags || tKey < 5")
                                span.label {{ tag.label }}
                                svg-icon.cursor(
                                    name='close' size="small"
                                    v-if="monitoringActionAllowed"
                                    @click.native="removeTag(tag.id)")

                            div.autocomplete-reference.l-flex-row.l-align-center(v-if="monitoringActionAllowed && displayTagInput")
                                input.edit-single-input-raw(
                                    v-model="inputTagValue"
                                    name="tag"
                                    placeholder="+ add tags"
                                    autocomplete="off"
                                    @keyup.enter="handleInputTag()"
                                    @keyup="debounceLoadTags(inputTagValue, $event)"
                                    @keyup.delete="debounceLoadTags(inputTagValue, $event)"
                                    @keyup.down="navigateAutoComplete(1)"
                                    @keyup.up="navigateAutoComplete(-1)"
                                    @keyup.esc="resetAutoCompleteTag()"
                                    maxlength="20"
                                    v-validate="'max:20'"
                                    )
                                span.form-validate-error(v-if="displayTagAlert") The tag field may contain alpha-numeric characters as well as dashes and underscores

                                //- Auto-complete Tag
                                div.overlay-close_light(
                                    v-if="tagSuggestionList.length >= 1 && inputTagValue.length >= 1"
                                    @click="closeAutoComplete")
                                ul.autocomplete-list.scrollbar.is-scrollable(
                                    v-if="tagSuggestionList.length >= 1 && inputTagValue.length >= 1"
                                )
                                    li.autocomplete-item(
                                        v-for="(tagSuggestion, idx) of tagSuggestionList"
                                        :class="{'is-selected': idx === cmpTagListCurrentIndex}"
                                        @click.stop="addTagSuggestion(tagSuggestion)"
                                    ) {{ tagSuggestion }}

                    span.form-validate-error.form-validate-error-tag {{ errors.first('tag') }}

        //- VOLUME ALERT
        section.detail-section.section-volume-alert
            div.sub-header.l-flex-row--between
                .sub-header-title.cursor.l-flex-row.l-align-center(
                    @click="toggleVolumeAlert()"
                    :class="toggleExpandVolumeAlertSection")
                    svg-icon.mg-r-4(name='arrow_bottom' size="small")
                    | Volume Alert
                .sub-header-action.l-flex-row(v-if="showVolumeAlert && audienceHasVolumeAlert && !volumeAlertLoading && monitoringActionAllowed" )
                    svg-icon(
                        name='edit' size='small'
                        @click.native="displayEditFormVolumeAlert()")
                    svg-icon(
                        name='trash' size='small'
                        @click.native="removeVolumeAlert()")

            transition(name="slide-fade")
                VolumeAlert(
                    :volumeAlert="this.audienceInfo.volumeAlert"
                    v-show="showVolumeAlert"
                )

        //- Summary
        section.detail-section
            div.sub-header.l-flex-row--between(@click="toggleSection('showSummary')")
                div.sub-header-title.cursor.l-flex-row.l-align-center(:class="toggleSummarySection")
                    svg-icon.mg-r-4(name='arrow_bottom' size="small")
                    | Summary

            transition(name="slide-fade")
                Summary(
                    v-show="showSummary"
                    parent="monitoring",
                    :summary="audienceSummary")
</template>

<script>
// Avoid repeating namespace for each store action/mutation/getter/state
import dayjs from 'dayjs'
import helpers from '@/store/data/audience/helpers'

import EmailCcField from '@/components/common/EmailCcField'
import SwitchItem from '@/components/common/SwitchItem'
import Summary from '@/components/common/Summary'
import VolumeAlert from '@/components/monitoring/VolumeAlert'
import { mapState, mapGetters, mapMutations, mapActions } from 'vuex'
import { isEmpty, isEqual, get, find, isNil, size, uniq, last, join, orderBy, debounce, head, filter, difference, xor, cloneDeep } from 'lodash'
import { validateTags } from '@/utils/helpers'

export default {
    name: 'MonitoringInfos',
    data() {
        return {
            displayEditSingleInput: {
                label: false,
                endDate: false,
                email: false,
                cc: false,
                tags: false,
                bootstrap: false
            },
            editEmailAudience: false,
            audienceFormLabel: null,
            audienceFormEndDate: null,
            audienceFormEmail: null,
            audienceFormStatus: null,
            audienceFormCc: [],
            audienceTagsList: [],
            hideAllTagsFor: [],
            showSummaryFor: [],
            maxTagsLimit: 50,
            tagListCurrentIndex: -1,
            newTagsList: [],
            inputTagValue: '',
            tagSuggestionList: [],
            selectedSuggestionTags: [],
            creatingTag: false,
            ccList: [],
            defaultCcValues: []
        }
    },
    props: {
        audienceInfo: { type: Object, required: true }
    },
    components: {
        EmailCcField,
        SwitchItem,
        Summary,
        VolumeAlert
    },
    mounted() {
        this.upDateAudienceForm()
        const cc = [cloneDeep(this.audienceInfo.cc)]
        this.defaultCcValues = !isEqual(cc, ['']) ? cc : []
    },
    watch: {
        activeTab: {
            handler: function(newValue, oldValue) {
                if (newValue !== oldValue) {
                    if (newValue === 'information') {
                        //to check if bootstrap start and push of stock buttons must be disabled or not
                        this.retrieveAttributionCounterAudience()
                    }
                }
            }
        },
        selectedAudienceId: {
            handler: function(newValue, oldValue) {
                if (!isNil(newValue) && !isEqual(newValue, oldValue)) {
                    this.setSelectedAudienceHaveDeletedCriteria({ result: false })
                    //to check if bootstrap start and push of stock buttons must be disabled or not
                    this.retrieveAttributionCounterAudience()
                    this.setAudienceVolumeAlert({
                        audienceId: newValue,
                        isVisibleInMonitoringPanel: false
                    })
                    this.inputTagValue = ''
                }
            }
        },
        showSummary: {
            handler(newValue) {
                if (newValue && this.audienceInfo && isEmpty(this.audienceInfo.summary)) {
                    this.handleRetrieveAudienceSummary()
                }
            }
        },
        audienceInfo: {
            handler: function(newValue) {
                if (!isNil(newValue.label)) {
                    this.audienceFormStatus = newValue.status
                    this.audienceFormLabel = newValue.label
                    this.audienceFormEndDate = dayjs(newValue.endDate).format('YYYY-MM-DD')
                    this.audienceFormEmail = newValue.email
                    this.audienceFormCc = isEmpty(newValue.cc) ? [] : newValue.cc.split(',')
                    this.audienceTagsList = isNil(newValue.tags) || isEmpty(newValue.tags) ? [] : newValue.tags
                }
            },
            deep: true
        },
        $route: {
            handler: function(newValue) {
                if (newValue.path !== '/' + this.accountId + '/monitoring') {
                    this.handleResetFieldOnLeave('label')
                    this.handleResetFieldOnLeave('email')
                }
            },
            deep: true
        }
    },

    computed: {
        // Call to state
        ...mapState('account', {
            accountId: state => state.accountId,
            attributionCounterAudience: state => state.attributionCounterAudience,
            attributionCounterTransfer: state => state.attributionCounterTransfer,
            dailyBootstrapLimit: state => state.dailyBootstrapLimit,
            userRole: state => state.userRole
        }),
        ...mapState('data/cclone', {
            ccloneList: state => state.list
        }),
        ...mapState('ui/monitoring', {
            activeTab: state => state.activeTab,
            selectedAudienceHaveDeletedCriteria: state => state.selectedAudienceHaveDeletedCriteria,
            selectedAudienceId: state => state.selectedRowId,
            genericFormulaVolumes: state => state.formulaVolumes
        }),
        ...mapState('ui/settings', {
            bootstrapPush: state => state.general.bootstrapPush
        }),
        ...mapState('ui/builder', {
            formulaLoading: state => state.isLoading.volumes
        }),
        //getters
        ...mapGetters('account', ['getIsMonitoringActionAllowed']),
        ...mapGetters('account', ['getUserAccess', 'getIsMonitoringActionAllowed', 'getAccessToCclone']),
        ...mapGetters('ui/builder', ['getThirdPartyOnlyInAudienceFormula']),

        inputClass() {
            return this.monitoringActionAllowed ? 'edit-single-input' : ' ui-disabled no-edit'
        },
        audienceSummary() {
            return this.audienceInfo.summary
        },
        monitoringActionAllowed() {
            return this.getIsMonitoringActionAllowed()
        },
        //condition if type is cclones to disable endDate at 395 days
        ccloneType() {
            return this.audienceInfo.type === 'cclones'
        },

        isOnlyThirdParty() {
            return !this.audienceInfo.has_1st_party && !this.ccloneType
        },

        // Disable endDate
        endDateOptions() {
            return {
                firstDayOfWeek: 1,
                disabledDate(time) {
                    return (
                        dayjs()
                            .startOf('day')
                            .valueOf() >
                            dayjs(time)
                                .startOf('day')
                                .valueOf() ||
                        dayjs(time).valueOf() >=
                            dayjs()
                                .startOf('day')
                                .add(395, 'day')
                                .valueOf()
                    )
                }
            }
        },
        audienceStatus() {
            return this.audienceFormStatus === 'active'
        },

        // Account
        displayBootstrap() {
            const { type } = this.audienceInfo
            if (type === 'cclones' && !this.bootstrapPush && this.userRole !== 'webo_admin') {
                return false
            }
            return this.audienceInfo.shouldShowBootstrap({
                bootstrapPush: this.bootstrapPush,
                managerAccess: this.getUserAccess({ type: 'manager_access' }),
                userRole: this.userRole
            })
        },
        isThirdPartyBootstrap() {
            return this.audienceInfo.isThirdPartyBootstrap({
                bootstrapPush: this.bootstrapPush,
                managerAccess: this.getUserAccess({ type: 'manager_access' }),
                userRole: this.userRole
            })
        },
        isBootstrapAllowed() {
            return this.audienceInfo.isBootstrapAllowed({
                userRole: this.userRole,
                getThirdPartyOnlyInAudienceFormula: this.getThirdPartyOnlyInAudienceFormula
            })
        },
        disableBootstrap() {
            return (
                this.selectedAudienceHaveDeletedCriteria
                || (
                    this.monitoringActionAllowed
                    && this.userRole !== 'webo_admin'
                    && this.limitDailyBootstrapNotSharedAudience
                ))

        },
        bootstrapWarning() {
            return this.selectedAudienceHaveDeletedCriteria
                ? 'Bootstrap is not available because one or more criteria does not exist anymore'
                : 'The account daily quota has been reached or would be exceeded. Bootstrap will be available when the quota is reset.'
        },

        limitDailyBootstrapNotSharedAudience() {
            return this.attributionCounterAudience + get(this.genericFormulaVolumes, `${this.selectedAudienceId}`, 0) >= this.dailyBootstrapLimit && !this.isShared
        },

        isShared() {
            return this.audienceInfo.isShared
        },

        // CC
        displayAddCc() {
            return !this.displayEditSingleInput.cc && this.audienceFormCc.length === 0 && this.monitoringActionAllowed
        },

        disableCcSave() {
            if (this.defaultCcValues) return isEqual(this.defaultCcValues, this.ccList)
            return this.ccList === 0
        },
        //Tags
        showAllTags() {
            return !this.hideAllTagsFor.includes(this.selectedAudienceId)
        },
        toggleExpandTagsSection() {
            return this.getToggleClass(this.showAllTags)
        },
        orderedTags() {
            return orderBy(this.audienceInfo.tags, 'audiences_tag_created_at')
        },
        displayTagInput() {
            return this.audienceTagsList.length < this.maxTagsLimit
        },
        cmpTagListCurrentIndex() {
            return this.tagListCurrentIndex
        },
        cmpTagListCurrentLabel() {
            return head(filter(this.tagSuggestionList, (tag, index) => index === this.cmpTagListCurrentIndex))
        },
        displayTagAlert() {
            if (!this.inputTagValue) return false
            const arrayTag = uniq(this.inputTagValue.split(/[\s,;\t\n]+/))
            return !validateTags(arrayTag)
        },

        hasUserAccessToCclone() {
            return this.getAccessToCclone()
        },
        classInfoBlockCcloneid() {
            return this.hasUserAccessToCclone ? 'info-block-ccloneid_lk' : 'info-block-ccloneid'
        },
        // Volume Alert
        volumeAlertDetails() {
            return this.audienceInfo.volumeAlert.details
        },
        volumeAlertLoading() {
            return this.audienceInfo.volumeAlert.isLoading
        },
        showVolumeAlert() {
            return this.audienceInfo.volumeAlert.isVisibleInMonitoringPanel
        },
        toggleExpandVolumeAlertSection() {
            return this.getToggleClass(this.showVolumeAlert)
        },
        audienceHasVolumeAlert() {
            return !isEmpty(this.volumeAlertDetails)
        },
        // Summary
        showSummary() {
            return this.showSummaryFor.includes(this.selectedAudienceId)
        },
        toggleSummarySection() {
            return this.getToggleClass(this.showSummary)
        }
    },

    methods: {
        // Call to actions
        ...mapActions('data/audience', [
            'addNewAudienceTags',
            'retrieveAudienceInfos',
            'retrieveAudienceVolumeFromAudience',
            'editAudience',
            'deleteTagFromAudience'
        ]),
        ...mapActions('data/cclone', ['retrieveCcloneDetails']),
        ...mapMutations('data/audience', ['setEditedAudience']),

        ...mapActions('ui/builder', ['requestAccountTags']),
        ...mapActions('account', ['retrieveAttributionCounterAudience']),
        ...mapActions('dashboardAccount', ['retrieveExpiringAudiences', 'retrieveExpiringTransfers']),

        // Call to mutations
        ...mapMutations('data/audience', ['setAudienceVolumeAlert']),
        ...mapMutations('ui/cclone', ['setSelectedCclone']),
        ...mapMutations('notifications', ['setAddedNotification']),
        ...mapMutations('ui/cclone', ['setSelectedCclone']),
        ...mapMutations('ui/monitoring', ['setSelectedAudienceHaveDeletedCriteria', 'setDisplayModal', 'setDeletedVolumeAlertId']),
        ...mapMutations('ui/volumeAlert', ['setShowVolumeAlertForm', 'setIsEditVolumeAlert']),

        /**
         * Trigger vuex action to get audience summary
         */
        handleRetrieveAudienceSummary() {
            this.retrieveAudienceInfos({
                type: 'summary',
                audienceId: this.audienceInfo.id,
                formula: this.audienceInfo.formula
            })
        },
        itemCssClasses(element) {
            let cssClasses = ''
            if (element === 'inactive') cssClasses += ' is-inactive'
            if (element === 'active') cssClasses += ' is-active'

            return cssClasses
        },
        toggleEditEmail(){
            this.editEmailAudience = !this.editEmailAudience
        },
        editAudienceInfo(dataToEdit, newValue, event) {
            this.audienceFormCc = this.ccList
            const {
                audienceFormLabel,
                audienceFormEndDate,
                audienceFormEmail,
                audienceFormCc,
                audienceInfo,
                selectedAudienceId,
                audienceTagsList,
                editAudience
            } = this

            const { displayEditSingleInput } = this

            if (this.monitoringActionAllowed) {
                this.$validator.validateAll().then(isValid => {
                    if (isValid) {
                        let _params
                        if (dataToEdit === 'endDate') _params = { params: { end_date: audienceFormEndDate }, notificationMessage: 'The date has been modified' }
                        else if (dataToEdit === 'email') _params = { params: { email: audienceFormEmail }, notificationMessage: 'The email has been modified' }
                        else if (dataToEdit === 'cc')
                            _params = { params: { email_cc: join(audienceFormCc, ',') }, notificationMessage: 'The email_cc has been modified' }
                        else if (dataToEdit === 'label') _params = { params: { label: audienceFormLabel }, notificationMessage: 'The label has been modified' }
                        else if (dataToEdit === 'bootstrap')
                            _params = { params: newValue, notificationMessage: 'The bootstrap ' + audienceInfo.label + ' has been added' }
                        else if (dataToEdit === 'audience-status') {
                            // if audience is set inactive, don't change the end date
                            if (!newValue) _params = { params: { status: 'inactive' }, notificationMessage: audienceInfo.label + ' has been set inactive' }
                            else {
                                const today = new Date()
                                const _endDate = new Date(audienceFormEndDate)
                                if (today.getTime() === _endDate.getTime() || _endDate < today) {
                                    // if audience is set active and the end date is today or before, change the end date (+ 30 days)
                                    const newEndDate = today.setDate(today.getDate() + 30)
                                    _params = {
                                        params: { status: 'active', end_date: dayjs(newEndDate).format('YYYY-MM-DD') },
                                        notificationMessage: audienceInfo.label + ' has been set active'
                                    }
                                } else {
                                    // if audience is set active and the end date after today, don't change the end date
                                    _params = { params: { status: 'active' }, notificationMessage: audienceInfo.label + ' has been set active' }
                                }
                            }
                        }

                        editAudience({ ..._params, id: selectedAudienceId, tags: audienceTagsList }).then(() => {
                            if (dataToEdit === 'label' || dataToEdit === 'email') event.target.blur()
                            if (dataToEdit === 'cc') this.defaultCcValues = this.ccList
                            this.retrieveExpiringAudiences()
                            this.retrieveExpiringTransfers()
                        })


                        // close edit modal
                        if (dataToEdit !== 'audience-status') {
                            displayEditSingleInput[dataToEdit] = false
                        }
                    }
                })
            }
        },
        RedirectToBuilder(ccloneId) {
            if (this.hasUserAccessToCclone) {
                const isCcloneAvailable = find(this.ccloneList, cclone => cclone.id === ccloneId)
                // We only target cclones that have not been deleted
                if (isCcloneAvailable) {
                    this.setSelectedCclone({ id: ccloneId })
                    this.retrieveCcloneDetails({ ccloneId })
                } else {
                    this.setAddedNotification({ type: 'error', message: 'This Cclone does not exists anymore' })
                    this.setSelectedCclone({ id: null })
                }
                this.$router.push({ path: '/' + this.accountId + '/builder/cclone' })
            } else return false
        },
        // Modal single edit
        displayEdit(field, transfer) {
            if (this.monitoringActionAllowed) {
                if (transfer) {
                    // edit transfer
                    if (field === 'label') this.transferFormLabel = { ...this.transferFormLabel, [transfer.id]: transfer.label }
                    else if (field === 'endDate') this.transferFormEndDate = { ...this.transferFormEndDate, [transfer.id]: transfer.end_date }
                    else if (field === 'email') this.transferFormEmail[transfer.id] = transfer.email
                    else if (field === 'cc') this.transferFormCc = isEmpty(transfer.cc) ? [] : transfer.cc.split(',')

                    if (!isNil(get(this.displayEditSingleInput[field], 'id', null))) {
                        this.displayEditSingleInput[field][transfer.id] = true
                    } else {
                        this.displayEditSingleInput[field] = { [transfer.id]: true }
                    }
                } else {
                    this.displayEditSingleInput[field] = true //edit audience
                }
            }
        },
        // CC
        updateFormCcList(ccList) {
            this.ccList = [...ccList]
        },
        closeEmailCcWrapper() {
            this.displayEditSingleInput.cc = false
        },

        // Tags
        handleInputTag() {
            if (!this.creatingTag) {
                this.creatingTag = true

                if (!isEmpty(this.tagSuggestionList) && !isNil(this.cmpTagListCurrentLabel)) {
                    // Select tag via keyboard navigation in autocomplete suggestion list
                    this.newTagsList.push(this.cmpTagListCurrentLabel)
                } else {
                    const arrayTagToAdd = uniq(this.inputTagValue.split(/[\s,;\t\n]+/))

                    // To avoid add empty tag
                    if (last(arrayTagToAdd) === '') return false

                    // To make sure we don't add more tags than current limit
                    if (this.audienceTagsList.length + size(arrayTagToAdd) > this.maxTagsLimit) {
                        this.setAddedNotification({ type: 'error', message: 'Tags have not been saved due to the the tag limit being reached' })
                        this.creatingTag = false
                        return false
                    }

                    if (!validateTags(arrayTagToAdd)) {
                        this.setAddedNotification({ type: 'error', message: 'Please do not use any special characters' })
                        this.creatingTag = false
                        return false
                    }

                    // Add tag one by one or by list
                    if ((size(arrayTagToAdd) === 1 && this.fields.tag.valid) || size(arrayTagToAdd) > 1) {
                        // check for duplicated tags in existing tags, and remove duplicated from new list
                        const existingTags = this.audienceInfo.tags !== null ? this.audienceInfo.tags.map(tag => tag.label) : []
                        const uniqTags = difference(arrayTagToAdd, existingTags)
                        // Ajouter tags existant
                        this.newTagsList = uniq(this.newTagsList.concat(uniqTags)).slice(0, this.maxTagsLimit)
                    }
                }
            }
            //if no tag to send to API, allow new tag
            if (isEmpty(this.newTagsList)) this.creatingTag = false
            // Update store and UI
            else this.saveAudienceTags()

            // Reset
            this.resetAutoCompleteTag()
        },

        saveAudienceTags() {
            const tagsParams = {
                id: this.selectedAudienceId,
                account_id: this.accountId,
                tags: JSON.stringify(this.newTagsList)
            }

            this.addNewAudienceTags(tagsParams)
                .then(audienceWithTags => {
                    if (!isEmpty(audienceWithTags)) {
                        const _audienceWithTags = {
                            ...audienceWithTags,
                            tags: audienceWithTags.tags.concat(this.audienceInfo.tags !== null ? this.audienceInfo.tags : [])
                        }
                        const audienceUpdated = helpers.apiToStore(_audienceWithTags)

                        this.setEditedAudience({ audience: audienceUpdated })
                    }
                })
                .finally(() => {
                    this.creatingTag = false
                    this.setAddedNotification({ type: 'success', message: 'A tag has been created' })
                })
        },

        resetAutoCompleteTag() {
            this.selectedSuggestionTags = []
            this.inputTagValue = ''
            this.newTagsList = []
            this.tagListCurrentIndex = -1
        },

        debounceLoadTags: debounce(function(tag, e) {
            if (e.keyCode === 40 || e.keyCode === 38) {
                // 40 down, 38 up
                return false
            }
            this.loadTags(tag)
        }, 200),
        loadTags(tag) {
            this.requestAccountTags(tag).then(response => {
                const apiResponse = response.map(tag => tag.label).sort()
                const exactMatching = filter(apiResponse, specialTag => specialTag.startsWith(tag))
                const formattedArray = uniq(exactMatching.concat(apiResponse))

                if (tag && tag.length >= 2) {
                    this.tagSuggestionList = isEmpty(this.tagList) ? formattedArray : difference(formattedArray, this.tagList)
                }
            })

            // Close the tag suggestion list
            if (this.inputTagValue.length === 0) this.tagSuggestionList = []
        },
        addTagSuggestion(tag) {
            const existingTags = this.audienceInfo.tags.map(tag => tag.label)
            if (!existingTags.includes(tag)) {
                this.newTagsList.push(tag)

                // Update store and UI
                this.saveAudienceTags()

                // Reset
                this.resetAutoCompleteTag()
            } else {
                this.setAddedNotification({ type: 'error', message: 'Tag already exists for this audience' })
            }
        },
        bootstrapAudience() {
            this.$emit('displayEditSingleInputBootstrap')
        },
        navigateAutoComplete(direction) {
            const maxIndex = size(this.tagSuggestionList) - 1

            if (direction === 1) {
                //down
                if (this.tagListCurrentIndex === -1) {
                    this.tagListCurrentIndex = 0 //case first tag
                } else if (this.tagListCurrentIndex < maxIndex) {
                    this.tagListCurrentIndex += direction //next element
                    document.getElementsByClassName('autocomplete-list')[0].scrollTop += 25 //manage scrolling
                }
            } else if (direction === -1) {
                //up
                if (this.tagListCurrentIndex > 0) {
                    this.tagListCurrentIndex += direction //next element
                    document.getElementsByClassName('autocomplete-list')[0].scrollTop -= 25 //manage scrolling
                }
            }
        },
        closeAutoComplete() {
            this.tagListCurrentIndex = -1
            this.tagSuggestionList = []
        },
        removeTag(tagId) {
            this.deleteTagFromAudience({
                audience: this.audienceInfo,
                tagId
            })
        },
        handleResetFieldOnLeave(field) {
            if (field === 'label') this.audienceFormLabel = this.audienceInfo.label
            else if (field === 'endDate') this.audienceFormEndDate = this.audienceInfo.endDate
            else if (field === 'email') {
                this.audienceFormEmail = this.audienceInfo.email
                this.editEmailAudience = false
            }
        },
        upDateAudienceForm() {
            this.audienceFormStatus = this.audienceInfo.status
            this.audienceFormLabel = this.audienceInfo.label
            this.audienceFormEndDate = dayjs(this.audienceInfo.endDate).format('YYYY-MM-DD')
            this.audienceFormEmail = this.audienceInfo.email
            this.audienceFormCc = isEmpty(this.audienceInfo.cc) ? [] : this.audienceInfo.cc.split(',')
            this.audienceTagsList = isNil(this.audienceInfo.tags) || isEmpty(this.audienceInfo.tags) ? [] : this.audienceInfo.tags
        },
        displayEditFormVolumeAlert() {
            this.setIsEditVolumeAlert({ isEdit: true })
            this.setShowVolumeAlertForm({ show: true })
        },
        removeVolumeAlert() {
            this.setDisplayModal({ item: 'volumeAlert', display: true })
            this.setDeletedVolumeAlertId({ volumeAlertId: this.volumeAlertDetails.id })
        },
        getToggleClass(expanded) {
            return expanded ? 'is-expanded' : 'is-collapsed'
        },
        toggleSection(sectionStateKey) {
            const stateKey = `${sectionStateKey}For`
            this[stateKey] = xor(this[stateKey], [this.selectedAudienceId])
        },
        toggleVolumeAlert() {
            this.setAudienceVolumeAlert({
                audienceId: this.selectedAudienceId,
                volumeAlert: {
                    isVisibleInMonitoringPanel: !this.audienceInfo.volumeAlert.isVisibleInMonitoringPanel
                }
            })
        }
    }
}
</script>
